module.exports = __webpack_public_path__ + "img/pic_number_70.828f873a.png";